import req from '../../api/request'
import type { EventPayload, SnEvent } from '../../features/event/types'

/**
 * Create an event on a schedule — a competition, season or division.
 *
 * The competition-side counterpart of `createEvent`, which creates under a
 * team's roster. A competition has no team of its own, so it cannot use that
 * one: it has no roster id to post to. The event created here belongs to the
 * schedule rather than to any team.
 */
export const createScheduleEvent = async (
  scheduleId: string,
  payload: EventPayload
): Promise<SnEvent> => {
  const response = await req(`/schedules/${scheduleId}/events`, {
    method: 'POST',
    body: JSON.stringify(payload),
  })
  return response.data as SnEvent
}
